/**
 * Shown only when `extractMessages` returns `undefined` — the server body carried no parseable
 * `message`. The server's own wording always takes priority when present; these strings never
 * override it.
 */
const FALLBACK_MESSAGES = {
	invitationGone: 'Cette invitation n’est plus valide.',
	passwordResetGone: 'Ce lien de réinitialisation n’est plus valide.',
	passwordResetRequestFailed: 'La demande de réinitialisation n’a pas pu être envoyée.',
} as const;

export default FALLBACK_MESSAGES;
